import "./ApprovalSummary.css";

interface ApprovalSummaryProps {
  totalApprovals: number,
  pendingApprovals: number
}

const ApprovalSummary = ({ 
  totalApprovals,
  pendingApprovals,
}: ApprovalSummaryProps) => {

return (
    <div className="ApprovalSummary">
      <div className="ApprovalSummary-1 ApprovalSummary-common">
        <span>Approval Summary</span>
      </div>
        <div className="ApprovalSummary-2 ApprovalSummary-common">
            <div className="totalApproval">
                <p>{totalApprovals}</p>
                <span className="totalApprovalQuantity">Total Approvals</span>
            </div>
        </div>

      <div className="ApprovalSummary-3 ApprovalSummary-common">
        <span>{pendingApprovals}</span>
        <span className="finalApprovalQuantity">Pending Approvals</span>
      </div>
    </div>
  );
};

export default ApprovalSummary;
